// Team Board display helpers (032) — one centralized place for the
// category option list/labels, mirroring utils/teamSchedule.js's own
// role for Schedule.

export const CATEGORY_LABELS = {
  announcement: 'Announcement',
  reminder: 'Reminder',
  practice_update: 'Practice Update',
  achievement: 'Achievement',
  other: 'Other',
};

/** True once a post has been edited after creation. created_at/
 * updated_at both default to now() at insert time and can differ by a
 * few milliseconds even on a brand-new, never-edited row — a small
 * tolerance avoids a fresh post spuriously showing an "edited"
 * indicator. */
export function isPostEdited(post) {
  if (!post?.created_at || !post?.updated_at) return false;
  return new Date(post.updated_at).getTime() - new Date(post.created_at).getTime() > 1000;
}
